import { useState, useRef, useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ReCAPTCHA from "react-google-recaptcha";
import { ApiBaseFront } from "../api/front/api-base-front";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../app/hooks";
import { recaptchaActions } from "../slices/recaptcha-slice";

export const RECAPTCHA_ACTIONS = {
  LOGIN: "login_action",
  STAFF_LOGIN: "staff_login_action",
  PASSWORD_RESET: "password_reset_action",
  STAFF_PASSWORD_RESET: "staff_password_reset_action",
} as const;

type RecaptchaAction = typeof RECAPTCHA_ACTIONS[keyof typeof RECAPTCHA_ACTIONS];

export const useRecaptcha = () => {
  const dispatch = useDispatch();
  const { needV2 } = useAppSelector((state) => ({ needV2: state.recaptcha.needV2 }));
  const { executeRecaptcha } = useGoogleReCaptcha();
  const v2Ref = useRef<ReCAPTCHA>(null);
  const [showV2, setShowV2] = useState(false);

  const executeAction = useCallback((action: RecaptchaAction, callback: () => void) => {
    if (!executeRecaptcha) {
      console.error("reCAPTCHA v3の準備ができていません!!!");
      return;
    }
    executeRecaptcha(action).then((token) => {
      ApiBaseFront.recaptchaV3 = token;
      callback();
    }).catch((err) => console.error("v3トークン取得または処理中にエラー!!!:", err));
  }, [executeRecaptcha]);

  const triggerV2 = useCallback(() => {
    setShowV2(true);
    dispatch(recaptchaActions.setNeedV2(true));
  }, [dispatch]);

  const resetV2 = useCallback(() => {
    v2Ref.current?.reset();
    setShowV2(false);
  }, []);

  const onV2Change = useCallback((token: string | null, onSuccess: () => void) => {
    if (token) {
      ApiBaseFront.recaptchaV2 = token;
      onSuccess();
    } else {
      console.error('V2のトークン発行に失敗しました!!!');
    }
    resetV2();
  }, []);

  return {
    v3: {
      getToken: executeAction,
    },
    v2: {
      v2Ref,
      showV2,
      needV2,
      triggerV2,
      onV2Change,
    }
  };
};
